import React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';

import './styles.css';


function getDefaultDate(value, type) {
  if (value && value !== '//') {
    switch (type) {
      case 'Y':
        return value.split('/')[2];
      case 'M':
        return value.split('/')[0];
      case 'D':
        return value.split('/')[1];
      default:
        return '';
    }
  }
  return '';
}

function cleanValue(v) {
  return v.replace(/\D/g, '');
}


class Component extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      month: getDefaultDate(props.value, 'M'),
      day: getDefaultDate(props.value, 'D'),
      year: getDefaultDate(props.value, 'Y'),
    };

    this.updateMonth = this.updateMonth.bind(this);
    this.updateDay = this.updateDay.bind(this);
    this.updateYear = this.updateYear.bind(this);
    this.validate = this.validate.bind(this);
    this.zeroPadDay = this.zeroPadDay.bind(this);
    this.zeroPadMonth = this.zeroPadMonth.bind(this);
  }

  updateMonth(e) {
    this.setState(
      { month: cleanValue(e.target.value) },
      () => {
        if (this.state.day && this.state.year) {
          this.validate();
        }
      },
    );
  }

  updateDay(e) {
    this.setState(
      { day: cleanValue(e.target.value) },
      () => {
        if (this.state.month && this.state.year) {
          this.validate();
        }
      },
    );
  }

  zeroPadDay() {
    let { day } = this.state;
    if (day && day.length < 2) {
      day = `0${day}`;
    }
    this.setState({ day });
  }

  zeroPadMonth() {
    let { month } = this.state;
    if (month && month.length < 2) {
      month = `0${month}`;
    }
    this.setState({ month });
  }

  updateYear(e) {
    this.setState(
      { year: cleanValue(e.target.value) },
      () => {
        if (this.state.day && this.state.month) {
          this.validate();
        }
      },
    );
  }

  validate() {
    const date = `${this.state.month}/${this.state.day}/${this.state.year}`;
    this.props.touch(this.props.name);
    this.props.onChange(date);
  }

  render() {
    return (
      <div styleName="birthdayContainer">
        <div styleName="birthdayHeader">
          Date of Birth
        </div>
        <input
          styleName="monthField"
          type="text"
          placeholder="MM"
          maxLength="2"
          value={this.state.month}
          onChange={this.updateMonth}
          onBlur={this.zeroPadMonth}
        />
        <input
          styleName="dayField"
          type="text"
          placeholder="DD"
          maxLength="2"
          value={this.state.day}
          onChange={this.updateDay}
          onBlur={this.zeroPadDay}
        />
        <input
          styleName="yearField"
          type="text"
          placeholder="YYYY"
          maxLength="4"
          value={this.state.year}
          onChange={this.updateYear}
          onBlur={this.validate}
        />
      </div>
    );
  }
}

Component.displayName = 'BirthdayField';

const mapDispatchToProps = dispatch => ({
  touch: model => (dispatch(actions.setTouched(model, true))),
});

export default connect(() => ({}), mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/Forms/Controls/BirthdayField.js